var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.formChoice==='urban')?_c('Urban'):(_vm.formChoice==='nile_ug')?_c('NileUg'):_c('DefaultCreate')
}
var staticRenderFns = []

export { render, staticRenderFns }